import { ProjectSettingAPI } from "../api";

export class ProjectSetting {
  constructor(props) {
    for (const [key, value] of Object.entries(props)) {
      this[key] = value;
    }
  }
  static async updateProjectSetting(payload) {
    const { data } = await ProjectSettingAPI.updateProjectSetting(payload);
    return new ProjectSetting(data.result)
  }
}
